"use client"
/* */
import { jsx, jsxs } from 'react/jsx-runtime';
import styles from './SectionHeader.module.scss.mjs';
import clsx from 'clsx';
import '../../../../lib/propsContext/propsContext.mjs';
import 'react';
import '../../../../lib/viewComponentContext/viewComponentContext.mjs';
import { PropsContextProvider } from '../../../../lib/propsContext/PropsContextProvider.mjs';
import { TunnelProvider, TunnelExit } from '@mittwald/react-tunnel';

const SectionHeader = (props) => {
  const { children, className, ref } = props;
  const rootClassName = clsx(styles.sectionHeader, className);
  const propsContext = {
    Switch: {
      labelPosition: "leading",
      tunnelId: "actions"
    },
    Button: {
      size: "s",
      tunnelId: "actions"
    },
    FileField: { tunnelId: "actions", Button: { size: "s" } },
    ContextMenuTrigger: {
      tunnelId: "actions",
      Button: {
        tunnelId: null
      }
    },
    PopoverTrigger: {
      tunnelId: "actions",
      Button: {
        tunnelId: null
      }
    },
    ModalTrigger: {
      tunnelId: "actions",
      Button: {
        tunnelId: null
      }
    },
    ContextualHelpTrigger: {
      tunnelId: "actions",
      Button: {
        tunnelId: null
      }
    },
    Action: {
      tunnelId: "actions",
      Button: {
        tunnelId: null
      }
    },
    Heading: {
      level: 2
    },
    Link: {
      tunnelId: "actions"
    }
  };
  return /* @__PURE__ */ jsx("header", { ref, className: rootClassName, children: /* @__PURE__ */ jsx(PropsContextProvider, { props: propsContext, children: /* @__PURE__ */ jsxs(TunnelProvider, { children: [
    children,
    /* @__PURE__ */ jsx("div", { className: styles.actions, children: /* @__PURE__ */ jsx(TunnelExit, { id: "actions" }) })
  ] }) }) });
};

export { SectionHeader, SectionHeader as default };
//# sourceMappingURL=SectionHeader.mjs.map
